<template>
  <div class="v-application">
    <div
      class="y-doc-review-award-banner"
      :class="{ 'w-100': isMobile }"
    >
      <div class="text-subtitle-1 mb-4">
        {{ title }}
      </div>

      <div class="d-flex">
        <v-btn
          class="mr-3"
          color="secondary"
          data-google-goal="click_leave_review_pay"
          :href="reviewLink"
          depressed
        >
          <span class="bg-gray-0--text">
            {{ t('Оставить отзыв', { ns: language }) }}
          </span>
        </v-btn>
        <v-btn
          color="text"
          target="_blank"
          rel="noopener noreferrer"
          :href="fileReviewProgramm"
          text
        >
          {{ t('Подробнее', { ns: language }) }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'

const isMobile = window.MOBILE_VERSION
const currencyName = window.CURRENCY_DATA.nameShortPluralGenitive

const { t, language } = I18NextVue

const props = defineProps<{
  ydocRateAwardAmount: string
  reviewLink: string
}>()

const title = t(
  'Получите {ydocRateAwardAmount} {currencyName} за отзыв.',
  {
    ns: language,
    ydocRateAwardAmount: props.ydocRateAwardAmount,
    currencyName: currencyName.toLowerCase(),
  },
)

const isByOrKgCountry = window.COUNTRY_DATA.iso === 'BY' || window.COUNTRY_DATA.iso === 'KG'
const fileReviewProgramm = isByOrKgCountry
  ? '/static/_v1/ydoc/documents/YDoc-review-award-programm-by-kg.pdf'
  : '/static/_v1/ydoc/documents/YDoc-review-award-programm.pdf'
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.y-doc-review-award-banner {
  width: 342px;
  border-radius: $border-radius-lg;
  background-color: $ui-kit-bg-error;
  padding: 16px;
}
</style>
